var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHttps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "78px",
    viewBox: "0 0 79 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selectHTTPS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalogue-des-Sources",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "selectHTTPS",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "web",
    transform: "translate(24.000000, 13.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.54,18 C21.66,17.01 21.75,16.02 21.75,15 C21.75,13.98 21.66,12.99 21.54,12 L26.61,12 C26.85,12.96 27,13.965 27,15 C27,16.035 26.85,17.04 26.61,18 M18.885,26.34 C19.785,24.675 20.475,22.875 20.955,21 L25.38,21 C23.94,23.475 21.645,25.395 18.885,26.34 M18.51,18 L11.49,18 C11.34,17.01 11.25,16.02 11.25,15 C11.25,13.98 11.34,12.975 11.49,12 L18.51,12 C18.645,12.975 18.75,13.98 18.75,15 C18.75,16.02 18.645,17.01 18.51,18 M15,26.94 C13.755,25.14 12.75,23.145 12.135,21 L17.865,21 C17.25,23.145 16.245,25.14 15,26.94 M9,9 L4.62,9 C6.045,6.51 8.355,4.59 11.1,3.66 C10.2,5.325 9.525,7.125 9,9 M4.62,21 L9,21 C9.525,22.875 10.2,24.675 11.1,26.34 C8.355,25.395 6.045,23.475 4.62,21 M3.39,18 C3.15,17.04 3,16.035 3,15 C3,13.965 3.15,12.96 3.39,12 L8.46,12 C8.34,12.99 8.25,13.98 8.25,15 C8.25,16.02 8.34,17.01 8.46,18 M15,3.045 C16.245,4.845 17.25,6.855 17.865,9 L12.135,9 C12.75,6.855 13.755,4.845 15,3.045 M25.38,9 L20.955,9 C20.475,7.125 19.785,5.325 18.885,3.66 C21.645,4.605 23.94,6.51 25.38,9 M15,-6.66133815e-16 C6.705,-6.66133815e-16 0,6.75 0,15 C0,18.9782473 1.58035261,22.793556 4.39339828,25.6066017 C7.20644396,28.4196474 11.0217527,30 15,30 C23.2842712,30 30,23.2842712 30,15 C30,11.0217527 28.4196474,7.20644396 25.6066017,4.39339828 C22.793556,1.58035261 18.9782473,-6.66133815e-16 15,-6.66133815e-16 L15,-6.66133815e-16 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHttps);
export default __webpack_public_path__ + "static/media/https.102ce36a2f5a35cecde4e179f85063b3.svg";
export { ForwardRef as ReactComponent };